import { useQuery } from '@tanstack/react-query';

import { warehouseApi } from 'api/warehouse';
import { ApiError } from 'shared/errors/ApiError';

export const FACILITY_FEATURE_FLAGS_QUERY_KEY = 'facilityFeatureFlags';

export const facilityFeatureFlagsQueryKeys = {
    all: [FACILITY_FEATURE_FLAGS_QUERY_KEY],
    byFacility: (facilityId) => [FACILITY_FEATURE_FLAGS_QUERY_KEY, facilityId],
};

/**
 * Fetches whitelisted facility feature flags and their enabled state.
 *
 * @param {Object} [options]
 * @param {number|string|null|undefined} options.facilityId
 * @param {boolean} [options.enabled=true]
 */
export function useFacilityFeatureFlagsQuery({ enabled = true, facilityId } = {}) {
    return useQuery({
        enabled: Boolean(enabled && facilityId),
        queryKey: facilityFeatureFlagsQueryKeys.byFacility(facilityId),
        retry: false,
        queryFn: async ({ signal }) => {
            const response = await warehouseApi.getFacilityFeatureFlags(facilityId, { signal });
            if (!response?.status) {
                throw new ApiError(
                    response?.msg ?? 'Failed to fetch facility feature flags',
                    response?.statusCode,
                    response?.data,
                );
            }
            return {
                flags: response.data?.flags ?? [],
            };
        },
    });
}
